import { type Team, type TeamUserInfoDTO, type UserRequirement } from '@capsicum/common';
import { atom } from 'jotai';

export enum TeamTagEnum {
	Qualified = 'qualified',
	Top10 = 'top10'
}

export enum TeamRegionEnum {
	Africa = 'africa',
	Asia = 'asia',
	Europe = 'europe',
	NorthAmerica = 'northAmerica',
	Oceania = 'oceania',
	SouthAmerica = 'southAmerica'
}

export enum TokensTabFilters {
	// Top10 = 'top10',
	Africa = 'africa',
	All = 'all',
	Asia = 'asia',
	Europe = 'europe',
	NorthAmerica = 'northAmerica',
	Oceania = 'oceania',
	SouthAmerica = 'southAmerica'
}

export const enum WCPledgeStatus {
	CLOSED = 'closed',
	OPENED = 'opened'
}

export enum WCPledgeTutorialSteps {
	Fifth = 5,
	Final = 7,
	First = 1,
	Fourth = 4,
	Second = 2,
	TenPercentExtra = 6,
	Third = 3
}

export type WCPledgeTeam = TeamUserInfoDTO & {
	flagUrl: string;
	priceInCHZ?: number;
};

export type WCPledgeActivityTeam = Team & {
	flagUrl: string;
};

export type WCPledgeBasketItem = {
	amount: number;
	ftName: string;
	teamId: string;
	usdAmount: number;
};

export type WCPledgeBasketItemWithTeamData = WCPledgeTeam & WCPledgeBasketItem;

export const stepIndexAtom = atom<WCPledgeTutorialSteps>(WCPledgeTutorialSteps.First);

export type WCPledgeBasketFooterProps = {
	formattedTotalPledgeAmount?: string;
	variant: 'basketDetails' | 'itemSelection';
};

export enum WCPledgeBasketFooterVariantEnum {
	BASKET_DETAILS = 'basketDetails',
	ITEM_SELECTION = 'itemSelection'
}

export enum WCPledgeReviewTransactionType {
	CLAIM = 'claim',
	UNSTAKE = 'unstake'
}

type BaseWCPledgeReviewTexts = {
	action: string;
	button: string;
	disclaimer: string;
	networkFee: {
		title: string;
		tooltip: string;
	};
	pageTitle: string;
	smartContractAddress: {
		title: string;
		tooltip: string;
	};
	snackbar: {
		description: string;
		title: string;
	};
	subtitle: string;
	title: string;
	transactionValue: string;
};

type BaseWCPledgeReviewProps = {
	isConfirmButtonDisabled: boolean;
	isLoading: boolean;
	sendTransactionHandler: () => void;
	texts: BaseWCPledgeReviewTexts;
	transactionDetails: {
		gasFeeEstimate?: number;
		gasFeeEstimateFiat?: string;
		isTransactionPending?: boolean;
		smartContractAddress?: string;
	};
};

export type WCPledgeReviewProps =
	| (BaseWCPledgeReviewProps & {
			operationDetails: {
				currencyLogo: string;
				stakedOn: string;
			};
			texts: BaseWCPledgeReviewTexts & {
				stakedOn: string;
			};
			transactionType: WCPledgeReviewTransactionType.UNSTAKE;
	  })
	| (BaseWCPledgeReviewProps & {
			transactionType: WCPledgeReviewTransactionType.CLAIM;
	  });

/**
 * Extracts the texts type for a specific transaction type
 * @example WCPledgeReviewTexts<WCPledgeReviewTransactionType.UNSTAKE>
 */
export type WCPledgeReviewTexts<T extends WCPledgeReviewTransactionType> =
	T extends WCPledgeReviewTransactionType.UNSTAKE
		? BaseWCPledgeReviewTexts & { stakedOn: string }
		: BaseWCPledgeReviewTexts;

export type WCPledgeRequirementModalProps = {
	closeModal: () => void;
	onAgree?: () => void;
	onDisagree?: () => void;
	requirement: UserRequirement;
	testID: string;
};
